
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/text-to-speech",
      function () {
        return require("private-next-pages/text-to-speech.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/text-to-speech"])
      });
    }
  